import React from 'react'

const CircleBlackOutline = () => {
  return (
<svg fill="#000000" width="15px" height="15px" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <circle cx="16" cy="16" r="16"/>
</svg>
  )
}

export default CircleBlackOutline